import { FC } from 'react';
import { JaaSMeeting } from '@jitsi/react-sdk';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { MixPanelEventTypes, PlatformTypes, mixPanelNavHandler } from '../../services/MixPanel';

const JitsiConferenceContainer = styled.div`
  & > .jitsi-iframe {
    height: 80vh;
  }
`;

interface JitsiConferenceProps {
  room: string;
  token: string;
  name: string;
}

const JitsiConference: FC<JitsiConferenceProps> = ({ room, token, name }) => {
  const history = useHistory();
  if (import.meta.env.VITE_JAAS_APP_ID && room && token) {
    return (
      <JitsiConferenceContainer>
        <JaaSMeeting
          userInfo={{
            displayName: name,
            email: '',
          }}
          jwt={token}
          appId={import.meta.env.VITE_JAAS_APP_ID}
          roomName={room}
          getIFrameRef={(iframeRef) => {
            iframeRef.classList.add('jitsi-iframe');
            iframeRef.removeAttribute('style');
          }}
          onReadyToClose={() => {
            mixPanelNavHandler(
              PlatformTypes.REMOTE_THERAPY,
              'Therapist Dashboard',
              MixPanelEventTypes.CLICK,
              'Video Conference',
              'Hangup'
            );
            history.push('/dashboard');
          }}
          configOverwrite={{
            hideConferenceSubject: true,
            securityUi: {
              hideLobbyButton: true,
            },
            welcomePage: {
              disabled: true,
            },
            prejoinConfig: {
              enabled: true,
              hideDisplayName: true,
            },
            readOnlyName: true,
            toolbarButtons: [
              'camera',
              'chat',
              'closedcaptions',
              'desktop',
              'fullscreen',
              'hangup',
              'help',
              'microphone',
              'noisesuppression',
              'participants-pane',
              'recording',
              'select-background',
              'settings',
              'shareaudio',
              'sharedvideo',
              'shortcuts',
              'stats',
              'tileview',
              'toggle-camera',
              'videoquality',
              'whiteboard',
            ],
          }}
        />
      </JitsiConferenceContainer>
    );
  }

  return <>Invalid configuration</>;
};

export default JitsiConference;
